export const DEFAULT_PAGE_LIMIT = 100;

export const getTotalCount = (responseData) =>
  responseData?.data?.pagination?.total ||
  responseData?.data?.pagination?.totalEntries ||
  responseData?.data?.pagination?.totalSessions ||
  responseData?.data?.pagination?.totalCount ||
  responseData?.pagination?.total ||
  responseData?.pagination?.totalEntries ||
  responseData?.pagination?.totalSessions ||
  responseData?.pagination?.totalCount ||
  responseData?.total ||
  responseData?.totalCount ||
  responseData?.count ||
  0;

export const getTotalPages = (responseData, pageLimit = DEFAULT_PAGE_LIMIT) =>
  responseData?.data?.pagination?.totalPages ||
  responseData?.data?.pagination?.pages ||
  responseData?.pagination?.totalPages ||
  responseData?.pagination?.pages ||
  responseData?.totalPages ||
  Math.ceil(getTotalCount(responseData) / pageLimit) ||
  1;

export const getPageItems = (responseData, keys = []) => {
  for (const key of keys) {
    if (Array.isArray(responseData?.data?.[key])) return responseData.data[key];
    if (Array.isArray(responseData?.[key])) return responseData[key];
  }

  if (Array.isArray(responseData?.data)) return responseData.data;
  if (Array.isArray(responseData)) return responseData;
  return [];
};

export const fetchAllPages = async (
  client,
  url,
  { params = {}, itemKeys = [], pageLimit = DEFAULT_PAGE_LIMIT } = {}
) => {
  const firstResponse = await client.get(url, {
    params: { ...params, page: 1, limit: pageLimit },
  });
  const firstData = firstResponse.data;
  const firstItems = getPageItems(firstData, itemKeys);
  const totalPages = getTotalPages(firstData, pageLimit);

  if (totalPages <= 1) return firstItems;

  const remainingResponses = await Promise.all(
    Array.from({ length: totalPages - 1 }, (_, index) =>
      client.get(url, {
        params: { ...params, page: index + 2, limit: pageLimit },
      })
    )
  );

  return [
    ...firstItems,
    ...remainingResponses.flatMap((response) => getPageItems(response.data, itemKeys)),
  ];
};
